<template>
  <div class="content control-id-page">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div slot="header" class="page-header">
            <div>
              <h4 class="card-title text-left mb-1">Relógios</h4>
              <p class="page-subtitle mb-0">
                Gerencie os equipamentos e suas sincronizações.
              </p>
            </div>
            <base-button
              type="success"
              class="new-clock-button"
              @click="$router.push('/cadastrarRelogios')"
            >
              <i class="tim-icons icon-simple-add"></i>
              Novo relógio
            </base-button>
          </div>

          <div class="table-toolbar">
            <div class="page-size-control">
              <span>Exibir</span>
              <el-select
                class="select-success pagination-select"
                v-model="pagination.perPage"
                placeholder="Por página"
              >
                <el-option
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
              <span>por página</span>
            </div>
            <base-input class="search-wrapper mb-0">
              <el-input
                type="search"
                class="search-input"
                clearable
                prefix-icon="el-icon-search"
                placeholder="Buscar por nome, modelo, serial ou IP"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </base-input>
          </div>

          <el-table
            :data="queriedData"
            class="clocks-table desktop-clocks-table"
            empty-text=" "
          >
            <el-table-column label="Relógio" :min-width="190">
              <template slot-scope="scope">
                <div class="clock-name">
                  <span class="clock-icon"
                    ><i class="tim-icons icon-watch-time"></i
                  ></span>
                  <div>
                    <strong>{{ scope.row.nome }}</strong>
                    <small>{{
                      scope.row.empresa || "Empresa não informada"
                    }}</small>
                    <small class="clock-serial">
                      Serial: {{ scope.row.nSerial || "—" }}
                    </small>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Equipamento" :min-width="190">
              <template slot-scope="scope">
                <div class="equipment-info" :title="scope.row.modelo">
                  <strong>{{ scope.row.modelo }}</strong>
                </div>
                <a
                  class="ip-link"
                  :href="clockUrl(scope.row)"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ scope.row.ip
                  }}<span v-if="scope.row.porta">:{{ scope.row.porta }}</span>
                  <i class="tim-icons icon-minimal-right"></i>
                </a>
              </template>
            </el-table-column>
            <el-table-column
              v-if="!isCompactTable"
              label="Atividade"
              :min-width="190"
            >
              <template slot-scope="scope">
                <div class="activity-info">
                  <span
                    ><i class="tim-icons icon-link-72"></i>
                    {{ scope.row.ultConex || "—" }}</span
                  >
                  <span
                    ><i class="tim-icons icon-refresh-01"></i>
                    {{ scope.row.ultSinc || "—" }}</span
                  >
                </div>
              </template>
            </el-table-column>

            <el-table-column :min-width="230" align="right" label="Ações">
              <template slot-scope="scope">
                <div class="action-buttons">
                  <el-tooltip
                    content="Editar dados do relógio"
                    effect="light"
                    placement="top"
                  >
                    <button
                      class="action-button action-button--edit"
                      @click="openEdit(scope.row)"
                    >
                      <i class="tim-icons icon-pencil"></i><span>Editar</span>
                    </button>
                  </el-tooltip>

                  <el-tooltip
                    :content="
                      scope.row.modelo === 'Evo'
                        ? 'Este modelo não utiliza sessão'
                        : 'Fazer novo login e salvar a sessão'
                    "
                    effect="light"
                    placement="top"
                  >
                    <button
                      class="action-button action-button--login"
                      :disabled="
                        scope.row.modelo === 'Evo' ||
                          syncingLoginId === scope.row.id
                      "
                      @click="syncLogin(scope.row)"
                    >
                      <i
                        :class="
                          syncingLoginId === scope.row.id
                            ? 'el-icon-loading'
                            : 'tim-icons icon-refresh-01'
                        "
                      ></i>
                      <span>Re-login</span>
                    </button>
                  </el-tooltip>

                  <template v-if="scope.row.modelo !== 'Evo'">
                    <el-tooltip
                      content="Sincronizar pontos"
                      effect="light"
                      placement="top"
                    >
                      <button
                        class="action-button action-button--icon"
                        @click="setRoute(scope.row)"
                      >
                        <i class="tim-icons icon-watch-time"></i>
                      </button>
                    </el-tooltip>
                    <el-tooltip
                      content="Sincronizar usuários"
                      effect="light"
                      placement="top"
                    >
                      <button
                        class="action-button action-button--icon"
                        @click="sincUsuario(scope.row)"
                      >
                        <i class="tim-icons icon-single-02"></i>
                      </button>
                    </el-tooltip>
                    <el-tooltip
                      v-if="
                        scope.row.modelo === 'IDFace/ IDFlex (Coletor REP-P)'
                      "
                      content="Sincronizar imagens"
                      effect="light"
                      placement="top"
                    >
                      <button
                        class="action-button action-button--icon"
                        @click="sincImagens(scope.row)"
                      >
                        <i class="tim-icons icon-image-02"></i>
                      </button>
                    </el-tooltip>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="mobile-clock-list">
            <article
              v-for="row in queriedData"
              :key="row.id"
              class="mobile-clock-card"
            >
              <div class="mobile-clock-card__header">
                <div class="clock-name">
                  <span class="clock-icon"
                    ><i class="tim-icons icon-watch-time"></i
                  ></span>
                  <div>
                    <strong>{{ row.nome }}</strong>
                    <small>{{ row.empresa || "Empresa não informada" }}</small>
                  </div>
                </div>
                <span class="mobile-model" :title="row.modelo">{{
                  row.modelo
                }}</span>
              </div>
              <div class="mobile-clock-card__details">
                <span><strong>Serial</strong>{{ row.nSerial || "—" }}</span>
                <span>
                  <strong>Endereço</strong>
                  <a
                    :href="clockUrl(row)"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ row.ip
                    }}<template v-if="row.porta">:{{ row.porta }}</template>
                  </a>
                </span>
              </div>
              <div class="mobile-clock-card__actions action-buttons">
                <el-tooltip
                  content="Editar dados do relógio"
                  effect="light"
                  placement="top"
                >
                  <button
                    class="action-button action-button--edit"
                    @click="openEdit(row)"
                  >
                    <i class="tim-icons icon-pencil"></i><span>Editar</span>
                  </button>
                </el-tooltip>
                <el-tooltip
                  :content="
                    row.modelo === 'Evo'
                      ? 'Este modelo não utiliza sessão'
                      : 'Fazer novo login e salvar a sessão'
                  "
                  effect="light"
                  placement="top"
                >
                  <button
                    class="action-button action-button--login"
                    :disabled="
                      row.modelo === 'Evo' || syncingLoginId === row.id
                    "
                    @click="syncLogin(row)"
                  >
                    <i
                      :class="
                        syncingLoginId === row.id
                          ? 'el-icon-loading'
                          : 'tim-icons icon-refresh-01'
                      "
                    ></i>
                    <span>Login</span>
                  </button>
                </el-tooltip>
                <template v-if="row.modelo !== 'Evo'">
                  <el-tooltip
                    content="Sincronizar pontos"
                    effect="light"
                    placement="top"
                  >
                    <button
                      class="action-button action-button--icon"
                      @click="setRoute(row)"
                    >
                      <i class="tim-icons icon-watch-time"></i>
                    </button>
                  </el-tooltip>
                  <el-tooltip
                    content="Sincronizar usuários"
                    effect="light"
                    placement="top"
                  >
                    <button
                      class="action-button action-button--icon"
                      @click="sincUsuario(row)"
                    >
                      <i class="tim-icons icon-single-02"></i>
                    </button>
                  </el-tooltip>
                  <el-tooltip
                    v-if="row.modelo === 'IDFace/ IDFlex (Coletor REP-P)'"
                    content="Sincronizar imagens"
                    effect="light"
                    placement="top"
                  >
                    <button
                      class="action-button action-button--icon"
                      @click="sincImagens(row)"
                    >
                      <i class="tim-icons icon-image-02"></i>
                    </button>
                  </el-tooltip>
                </template>
              </div>
            </article>
          </div>

          <div v-if="!isLoading && total === 0" class="empty-state">
            <i class="tim-icons icon-watch-time"></i>
            <strong>Nenhum relógio encontrado</strong>
            <span>Altere a busca ou cadastre um novo equipamento.</span>
          </div>

          <div slot="footer" class="table-footer">
            <p class="mb-0">
              <template v-if="total"
                >Mostrando {{ from + 1 }}–{{ to }} de
                {{ total }} relógios</template
              >
              <template v-else>Nenhum relógio para exibir</template>
            </p>
            <base-pagination
              class="pagination-no-border mb-0"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>
    </div>

    <el-dialog
      title="Editar relógio"
      :visible.sync="editDialogVisible"
      width="680px"
      custom-class="control-id-edit-dialog"
      :close-on-click-modal="false"
    >
      <div v-if="editModel" class="edit-form">
        <div class="row">
          <base-input
            class="col-md-6"
            label="Nome"
            v-model.trim="editModel.nome"
          />
          <base-input
            class="col-md-6"
            label="Empresa"
            v-model.trim="editModel.empresa"
          />
        </div>
        <div class="row">
          <div class="col-md-6 form-group">
            <label>Modelo</label>
            <el-select
              class="select-success edit-select"
              v-model="editModel.modelo"
              placeholder="Modelo"
            >
              <el-option
                v-for="item in modelos"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
          <div class="col-md-6 form-group">
            <label>Layout do arquivo</label>
            <el-select
              class="select-success edit-select"
              v-model="editModel.tipoAfd"
              placeholder="Layout"
              :disabled="editModel.modelo === 'Evo'"
            >
              <el-option label="Portaria 1510" value="1510" />
              <el-option label="Portaria 671" value="671" />
            </el-select>
          </div>
        </div>
        <div class="row">
          <base-input
            class="col-md-8"
            label="Host / IP"
            v-model.trim="editModel.ip"
          />
          <base-input
            class="col-md-4"
            label="Porta"
            v-model.trim="editModel.porta"
          />
        </div>
        <div class="row">
          <base-input
            class="col-md-6"
            label="Usuário de comunicação"
            v-model.trim="editModel.usuario"
          />
          <base-input
            class="col-md-6"
            label="Senha de comunicação"
            type="password"
            v-model="editModel.senha"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <base-button type="default" simple @click="editDialogVisible = false"
          >Cancelar</base-button
        >
        <base-button type="success" :disabled="savingEdit" @click="saveEdit">
          <i v-if="savingEdit" class="el-icon-loading"></i>
          Salvar alterações
        </base-button>
      </span>
    </el-dialog>

    <loading
      :active="isLoading"
      :can-cancel="false"
      loader="spinner"
      color="#35a887"
      :is-full-page="true"
    />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import { Card, BasePagination, BaseInput } from "@/components/index";
import {
  Table,
  TableColumn,
  Select,
  Option,
  Dialog,
  Tooltip,
  Input
} from "element-ui";
import { Notification } from "element-ui";
const https = require("https");

const httpsAgent = new https.Agent({ rejectUnauthorized: false });

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dialog.name]: Dialog,
    [Tooltip.name]: Tooltip,
    [Input.name]: Input,
    BasePagination,
    BaseInput
  },
  data() {
    return {
      pagination: { perPage: 5, currentPage: 1, perPageOptions: [5, 10, 20] },
      isLoading: false,
      savingEdit: false,
      syncingLoginId: null,
      editDialogVisible: false,
      editModel: null,
      viewportWidth: typeof window !== "undefined" ? window.innerWidth : 1440,
      searchQuery: "",
      tableData: [],
      modelos: [
        "REP IDClass (REP-C)",
        "IDClass 373 (REP-A)",
        "IDFace/ IDFlex (Coletor REP-P)",
        "Evo",
        "Outros"
      ]
    };
  },
  computed: {
    isCompactTable() {
      return this.viewportWidth < 1200;
    },
    filteredData() {
      const query = this.searchQuery.trim().toLowerCase();
      if (!query) return this.tableData;
      return this.tableData.filter(item =>
        Object.values(item).some(value =>
          String(value == null ? "" : value)
            .toLowerCase()
            .includes(query)
        )
      );
    },
    queriedData() {
      return this.filteredData.slice(this.from, this.to);
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    to() {
      return Math.min(this.from + this.pagination.perPage, this.total);
    },
    total() {
      return this.filteredData.length;
    }
  },
  watch: {
    searchQuery() {
      this.pagination.currentPage = 1;
    },
    "pagination.perPage"() {
      this.pagination.currentPage = 1;
    }
  },
  mounted() {
    window.addEventListener("resize", this.updateViewportWidth);
    this.listarRelogios();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateViewportWidth);
  },
  methods: {
    updateViewportWidth() {
      this.viewportWidth = window.innerWidth;
    },
    clockUrl(row) {
      return `https://${row.ip}${row.porta ? `:${row.porta}` : ""}`;
    },
    setRoute(row) {
      this.$router.push(`/sincronizarPontos/${row.id}`);
    },
    sincUsuario(row) {
      this.$router.push(`/sincronizarUsuarios/${row.id}`);
    },
    sincImagens(row) {
      this.$router.push(`/sincronizarImagens/${row.id}`);
    },
    openEdit(row) {
      this.editModel = {
        ...row,
        tipoAfd: row.modelo === "Evo" ? "" : String(row.tipoAfd || "1510")
      };
      this.editDialogVisible = true;
    },
    isEditValid() {
      const required = [
        "nome",
        "empresa",
        "modelo",
        "ip",
        "porta",
        "usuario",
        "senha"
      ];
      const hasRequiredFields = required.every(field =>
        String(
          this.editModel[field] == null ? "" : this.editModel[field]
        ).trim()
      );
      const hasAfdLayout =
        this.editModel.modelo === "Evo" ||
        ["1510", "671"].includes(String(this.editModel.tipoAfd));
      return hasRequiredFields && hasAfdLayout;
    },
    async saveEdit() {
      if (!this.isEditValid()) {
        this.notify(
          "Atenção",
          "Preencha todos os campos obrigatórios.",
          "warning"
        );
        return;
      }
      this.savingEdit = true;
      try {
        const relogio = {
          ...this.editModel,
          tipoAfd: this.editModel.modelo === "Evo" ? "" : this.editModel.tipoAfd
        };
        const response = await this.updateClock(relogio);
        if (
          response.data.status !== "success" ||
          response.data.data.status === false
        ) {
          throw new Error(
            response.data.message || "Não foi possível atualizar o relógio."
          );
        }
        const index = this.tableData.findIndex(item => item.id === relogio.id);
        if (index !== -1) this.$set(this.tableData, index, relogio);
        this.editDialogVisible = false;
        this.notify("Sucesso", "Dados do relógio atualizados.", "success");
      } catch (err) {
        console.error(err);
        this.notify(
          "Erro",
          "Não foi possível atualizar os dados do relógio.",
          "error"
        );
      } finally {
        this.savingEdit = false;
      }
    },
    async syncLogin(row) {
      if (row.modelo === "Evo" || this.syncingLoginId !== null) return;
      this.syncingLoginId = row.id;
      try {
        const isFaceId = row.modelo === "IDFace/ IDFlex (Coletor REP-P)";
        const url = isFaceId
          ? `https://${row.ip}:${row.porta}/login.fcgi`
          : `https://${row.ip}/login.fcgi`;
        const form = isFaceId
          ? { login: row.usuario, password: row.senha }
          : {
              ip: row.ip,
              porta: row.porta,
              login: row.usuario,
              password: row.senha
            };
        const loginResponse = await this.axios.post(url, form, { httpsAgent });
        if (!loginResponse.data || !loginResponse.data.session) {
          throw new Error("O equipamento não retornou uma nova sessão.");
        }
        const updatedClock = { ...row, sessao: loginResponse.data.session };
        const updateResponse = await this.updateClock(updatedClock);
        if (
          updateResponse.data.status !== "success" ||
          updateResponse.data.data.status === false
        ) {
          throw new Error("A sessão foi criada, mas não pôde ser salva.");
        }
        const index = this.tableData.findIndex(item => item.id === row.id);
        if (index !== -1) this.$set(this.tableData, index, updatedClock);
        this.notify(
          "Login sincronizado",
          "Uma nova sessão foi criada e salva com sucesso.",
          "success"
        );
      } catch (err) {
        console.error(err);
        const apiMessage =
          err.response && err.response.data && err.response.data.message;

        const messageError = apiMessage || err.message;
        this.notify(
          "Falha ao sincronizar login",
          messageError === "Network Error"
            ? "Verifique a conexão e as credenciais do relógio."
            : messageError,
          "error"
        );
      } finally {
        this.syncingLoginId = null;
      }
    },
    updateClock(relogio) {
      return this.axios.post("/api/relogio/updateSession", {
        setDB: this.$cookies.get("db"),
        relogio
      });
    },
    notify(title, message, type) {
      Notification({
        title,
        message,
        type,
        duration: 3000,
        offset: 20,
        position: "top-right"
      });
    },
    async listarRelogios() {
      this.isLoading = true;
      try {
        const response = await this.axios.post("/api/relogio/listarRelogios", {
          setDB: this.$cookies.get("db")
        });
        this.tableData = response.data.data.dados || [];
      } catch (err) {
        console.error(err);
        this.notify("Erro", "Erro ao listar relógios!", "error");
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.control-id-page .page-header,
.control-id-page .table-toolbar,
.control-id-page .table-footer,
.control-id-page .action-buttons,
.control-id-page .page-size-control,
.control-id-page .clock-name {
  display: flex;
  align-items: center;
}
.control-id-page .page-header {
  justify-content: space-between;
  gap: 20px;
}
.control-id-page .page-subtitle {
  color: #8f9bb3;
  font-size: 13px;
}
.control-id-page .new-clock-button i {
  margin-right: 7px;
}
.control-id-page .table-toolbar {
  justify-content: space-between;
  gap: 20px;
  padding: 18px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.control-id-page .page-size-control {
  gap: 9px;
  color: #8f9bb3;
  font-size: 12px;
  white-space: nowrap;
}
.control-id-page .pagination-select {
  width: 78px;
}
.control-id-page .search-wrapper {
  width: 360px;
}
.control-id-page .clock-name {
  gap: 11px;
}
.control-id-page .clock-name strong,
.control-id-page .clock-name small {
  display: block;
}
.control-id-page .clock-name small {
  color: #8f9bb3;
  margin-top: 2px;
  font-size: 11px;
}
.control-id-page .clock-name > div,
.control-id-page .equipment-info {
  min-width: 0;
}
.control-id-page .clock-name strong,
.control-id-page .equipment-info strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.control-id-page .clock-serial {
  opacity: 0.78;
}
.control-id-page .equipment-info {
  margin-bottom: 6px;
  max-width: 210px;
}
.control-id-page .equipment-info strong {
  color: #d9deea;
  font-size: 12px;
}
.control-id-page .activity-info {
  display: flex;
  flex-direction: column;
  gap: 7px;
  color: #8f9bb3;
  font-size: 11px;
}
.control-id-page .activity-info i {
  color: #35a887;
  margin-right: 5px;
}
.control-id-page .clock-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  color: #35a887;
  background: rgba(53, 168, 135, 0.13);
}
.control-id-page .ip-link {
  color: #35a887;
  font-weight: 600;
}
.control-id-page .ip-link i {
  font-size: 9px;
  margin-left: 5px;
}
.control-id-page .action-buttons {
  justify-content: flex-end;
  gap: 6px;
  white-space: nowrap;
}
.control-id-page .action-button {
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.04);
  color: #c8ceda;
  min-height: 34px;
  border-radius: 8px;
  padding: 0 10px;
  cursor: pointer;
  transition: 0.18s ease;
}
.control-id-page .action-button span {
  margin-left: 6px;
  font-size: 11px;
  font-weight: 600;
}
.control-id-page .action-button:hover {
  border-color: #35a887;
  color: #35a887;
  background: rgba(53, 168, 135, 0.09);
}
.control-id-page .action-button--edit {
  color: #63b3ed;
}
.control-id-page .action-button--login {
  color: #35a887;
}
.control-id-page .action-button--icon {
  width: 34px;
  padding: 0;
}
.control-id-page .action-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  border-color: rgba(255, 255, 255, 0.12);
}
.control-id-page .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 45px 20px;
  color: #8f9bb3;
  gap: 7px;
}
.control-id-page .empty-state i {
  font-size: 30px;
  color: #35a887;
  margin-bottom: 5px;
}
.control-id-page .table-footer {
  justify-content: space-between;
  padding: 16px 5px 0;
  color: #8f9bb3;
  font-size: 12px;
}
.control-id-page .edit-select {
  width: 100%;
}
.control-id-page .mobile-clock-list {
  display: none;
}
@media (max-width: 1400px) {
  .control-id-page .desktop-clocks-table .action-button span {
    display: none;
  }
  .control-id-page .desktop-clocks-table .action-button {
    width: 34px;
    padding: 0;
  }
}
@media (max-width: 767px) {
  .control-id-page .page-header,
  .control-id-page .table-toolbar,
  .control-id-page .table-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .control-id-page .new-clock-button,
  .control-id-page .search-wrapper {
    width: 100%;
  }
  .control-id-page .table-footer {
    align-items: center;
  }
  .control-id-page .desktop-clocks-table {
    display: none;
  }
  .control-id-page .mobile-clock-list {
    display: grid;
    gap: 12px;
    padding: 14px;
  }
  .control-id-page .mobile-clock-card {
    min-width: 0;
    padding: 15px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.025);
  }
  .control-id-page .mobile-clock-card__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }
  .control-id-page .mobile-clock-card__header .clock-name {
    min-width: 0;
  }
  .control-id-page .mobile-model {
    overflow: hidden;
    max-width: 42%;
    padding: 5px 8px;
    border-radius: 7px;
    background: rgba(53, 168, 135, 0.11);
    color: #35a887;
    font-size: 9px;
    font-weight: 600;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .control-id-page .mobile-clock-card__details {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 12px;
    margin: 15px 0;
    padding: 12px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.07);
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    color: #c8ceda;
    font-size: 11px;
  }
  .control-id-page .mobile-clock-card__details > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .control-id-page .mobile-clock-card__details strong {
    display: block;
    margin-bottom: 4px;
    color: #8f9bb3;
    font-size: 9px;
    font-weight: 500;
    text-transform: uppercase;
  }
  .control-id-page .mobile-clock-card__details a {
    color: #35a887;
  }
  .control-id-page .mobile-clock-card__actions {
    width: 100%;
    justify-content: flex-start;
    overflow: visible;
  }
  .control-id-page .mobile-clock-card__actions .action-button--edit,
  .control-id-page .mobile-clock-card__actions .action-button--login {
    flex: 1 1 auto;
  }
}
@media (max-width: 360px) {
  .control-id-page .mobile-clock-card__actions .action-button span {
    display: none;
  }
  .control-id-page .mobile-clock-card__actions .action-button {
    width: 34px;
    padding: 0;
  }
  .control-id-page .mobile-clock-card__actions .action-button--edit,
  .control-id-page .mobile-clock-card__actions .action-button--login {
    flex: 1 1 34px;
  }
}
</style>

<style>
.control-id-edit-dialog {
  max-width: calc(100% - 30px);
}
.control-id-edit-dialog .el-dialog__body {
  padding-top: 12px;
}
.control-id-edit-dialog .form-group label {
  display: block;
  font-size: 0.75rem;
  margin-bottom: 5px;
  color: #9a9a9a;
}
.control-id-edit-dialog .edit-select {
  width: 100%;
}


/* Notification styling for better visibility */
.el-notification {
  background-color: rgba(30, 30, 30, 0.9) !important;
  color: #ffffff !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  position: fixed !important;
  top: 20px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  z-index: 9999 !important;
}
.el-notification .el-notification__title {
  color: #ffffff !important;
}
.el-notification .el-notification__content,
.el-notification .el-notification__message,
.el-notification .el-notification__content * {
  color: #ffffff !important;
}
</style>
